export default __webpack_public_path__ + "media/images/svg/single-logo-icon-8fab5856da211fc1a635778a176c0470.svg";